import React from 'react';
import { motion } from 'framer-motion';
import { FaAward, FaExternalLinkAlt } from 'react-icons/fa';

const Achievements = () => {
  return (
    <section
      id="achievements"
      style={{
        padding: '80px 0',
        background: '#f0f8ff',
        fontFamily: 'Roboto',
      }}
    >
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            background: 'white',
            borderRadius: '20px',
            boxShadow: '0 10px 30px rgba(0,0,0,0.1)',
            overflow: 'hidden',
          }}
        >
          <div style={{ padding: '40px 20px', textAlign: 'center' }}>
            {/* Gradient badge icon */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
              <div
                style={{
                  background: 'linear-gradient(to right, #6b46c1, #3182ce)',
                  padding: '15px',
                  borderRadius: '50%',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                }}
              >
                <FaAward style={{ color: 'white', fontSize: '40px' }} />
              </div>
            </div>

            <h2
              style={{
                fontSize: '24px',
                fontWeight: 'bold',
                marginBottom: '20px',
                color: 'blue',
              }}
            >
              Achievements
            </h2>

            <p
              style={{
                color: '#333',
                fontSize: '18px',
                marginBottom: '30px',
                lineHeight: '1.6',
                fontFamily: 'Roboto', 
              }}
            >
              Our team <span style={{ fontWeight: 'bold', color: '#007bff' }}>SEVENKY</span> bagged{' '}
              <span style={{ fontWeight: 'bold' }}>15th position</span> as a finalist in the{' '}
              <span style={{ fontStyle: 'italic' }}>SWADESHI Microprocessor Challenge</span> - Innovate Solutions for आत्मनिर्भर भारत funded by the Ministry of Electronics and Information Technology, Government of India.
            </p>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: '15px',
              }}
            >
              <a
                href="https://makervillage.in/swadeshichallenge.html"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 25px',
                  background: '#007bff',
                  color: 'white',
                  borderRadius: '25px',
                  textDecoration: 'none',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                  transition: 'background 0.3s',
                }}
                onMouseOver={(e) => (e.currentTarget.style.background = '#0056b3')}
                onMouseOut={(e) => (e.currentTarget.style.background = '#007bff')}
              >
                View Challenge Details
                <FaExternalLinkAlt style={{ fontSize: '18px' }} />
              </a>

              <a
                href="https://www.meity.gov.in/writereaddata/files/announcement_of_finalists_under_swadeshi_microprocessor_challenge.pdf"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  padding: '10px 25px',
                  background: 'white',
                  border: '2px solid #007bff',
                  color: '#007bff',
                  borderRadius: '25px',
                  textDecoration: 'none',
                  boxShadow: '0 4px 10px rgba(0,0,0,0.1)',
                  transition: 'all 0.3s',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.background = '#007bff';
                  e.currentTarget.style.color = 'white';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.background = 'white';
                  e.currentTarget.style.color = '#007bff';
                }}
              >
                View Results
                <FaExternalLinkAlt style={{ fontSize: '18px' }} />
              </a>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Achievements;
